export const UPDATE_PATIENT_DETAIL = "UPDATE_PATIENT_DETAIL"
export const UPDATE_PATIENT_DETAIL_FAIL = "UPDATE_PATIENT_DETAIL_FAIL"
export const UPDATE_PATIENT_DETAIL_SUCCESS = "UPDATE_PATIENT_DETAIL_SUCCESS"
export const UPDATE_PATIENT_DETAIL_RESET = "UPDATE_PATIENT_DETAIL_RESET"

export const updatePatientDetail = (params) => {
    return { type: UPDATE_PATIENT_DETAIL, params }
}

export const updatePatientDetailSuccess = (response) => {
    return { type: UPDATE_PATIENT_DETAIL_SUCCESS, response }
}

export const updatePatientDetailFail = (response) => {
    return { type: UPDATE_PATIENT_DETAIL_FAIL, response }
}

export const updatePatientDetailResetState = () => {
    return { type: UPDATE_PATIENT_DETAIL_RESET }
}